import axios from 'axios';


const instance = axios.create();
instance.defaults.headers.common["x-api-key"] = "esFKdLxIl69faZ6hOOfLu8fPoSfEpauL1NYgp7CO";

export default instance;